import { render, staticRenderFns } from "./MiraDonut.vue?vue&type=template&id=019e8583&scoped=true&"
import script from "./MiraDonut.vue?vue&type=script&lang=ts&"
export * from "./MiraDonut.vue?vue&type=script&lang=ts&"
import style0 from "./MiraDonut.vue?vue&type=style&index=0&id=019e8583&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019e8583",
  null
  
)

export default component.exports